import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ShieldCheck, Shield, Locate, User, ClipboardList, Cpu } from "lucide-react";

export default function HeroSlider() {
  const slides = [
    {
      title: "Security Consulting for Property Managers",
      desc: "Argus provides professional security consulting services including risk assessments, security program development, and property protection strategies.",
      icon: <ClipboardList className="w-10 h-10 text-white" />,
      bg: "https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg",
      link: "/consulting",
    },

    {
      title: "Technology & Innovation",
      desc: "Argus integrates modern technology such as surveillance systems, remote monitoring, drone security, and AI-powered patrol solutions.",
      icon: <Cpu className="w-10 h-10 text-white" />,
      bg: "https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg",
      link: "/technology",
    },

    {
      title: "Emergency Security Coverage",
      desc: "Rapid-response security services including emergency guards, fire watch coverage, and mobile patrol support available 24/7.",
      icon: <ShieldCheck className="w-10 h-10 text-white" />,
      bg: "https://images.pexels.com/photos/11053640/pexels-photo-11053640.jpeg",
      link: "/emergencies",
    },
  ];

  return (
    <section className="w-full">
      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 4500 }}
        loop
        pagination={{ clickable: true }}
        className="w-full"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="relative h-[60vh] md:h-[65vh] w-full flex items-center justify-center">
              <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70 z-0" />

              <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="relative z-10 bg-white/10 backdrop-blur-lg p-8 md:p-12 rounded-2xl shadow-2xl text-center border border-[#c4122f]/50 max-w-3xl mx-4"
              >
                <div className="mb-6">
                  <div className="bg-gradient-to-br from-[#c4122f] to-red-900 p-4 rounded-full shadow-lg inline-flex items-center justify-center">
                    {slide.icon}
                  </div>
                </div>

                <h2 className="text-2xl md:text-4xl font-bold text-white mb-4 drop-shadow">
                  {slide.title}
                </h2>
                <p className="text-gray-100 text-lg md:text-lg mb-6 drop-shadow">
                  {slide.desc}
                </p>

                <Link
                  to={slide.link}
                  className="inline-block bg-gradient-to-r from-[#c4122f] to-red-900 hover:from-[#c4122f] hover:to-red-900 text-white px-6 py-3 rounded-full font-medium text-md shadow-lg transition-all duration-300 hover:scale-105"
                >
                  Explore More
                </Link>
              </motion.div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
